import { create } from "zustand";
import { useShallow } from "zustand/react/shallow";
import type { IUnsplashImage } from "@/shared/types";
import { IMAGES_PANEL_MASONRY_COLS } from "../constants";
import type { IImagesPanelImage } from "../types";
import { stockImagesToCols } from "../utils";

interface IState {
  columnsData: IImagesPanelImage[][];
  category: string;
  queryRaw: string;
}

interface IActions {
  setColumnsData: (data: {
    images: IUnsplashImage[];
    extend?: boolean;
  }) => void;
  setCategory: (value: string) => void;
  setQueryRaw: (value: string) => void;
  reset: () => void;
}

const initState: IState = {
  columnsData: Array.from({ length: IMAGES_PANEL_MASONRY_COLS }, () => []),
  category: "",
  queryRaw: "",
};

export const useImagesPanelStockStore = create<IState & IActions>((set) => ({
  ...initState,
  setColumnsData: ({ images, extend }) => {
    return set((s) => ({
      columnsData: stockImagesToCols({ images, extend })(s.columnsData),
    }));
  },
  setCategory: (category) => set({ category }),
  setQueryRaw: (queryRaw) => set({ queryRaw }),
  reset: () => set(initState),
}));

export const useImagesPanelStockStoreShallow = <U>(
  selector: (store: IState & IActions) => U,
) => {
  return useImagesPanelStockStore(useShallow(selector));
};
